export var DateIntervalEnum;
(function (DateIntervalEnum) {
    DateIntervalEnum["YEAR"] = "years";
    DateIntervalEnum["MONTH"] = "months";
    DateIntervalEnum["DAY"] = "days";
    DateIntervalEnum["HOUR"] = "hours";
    DateIntervalEnum["MINUTE"] = "minutes";
    DateIntervalEnum["SECOND"] = "seconds";
    DateIntervalEnum["WEEK"] = "weeks";
})(DateIntervalEnum || (DateIntervalEnum = {}));
